import { transform, isArray, isObject, kebabCase, camelCase } from 'lodash';

/**
  * returns the result of recursively applying a function `f` to the keys of an object
* @param {object | object[]} obj
* @param {(s: string | number | symbol) => string | number | symbol} f
*/
export function mapKeys(obj, f) {
  return transform(obj, (result, value, key, target) => {
    const newKey = isArray(target) ? key : f(key);
    result[newKey] = isObject(value) ? mapKeys(value, f) : value;
  });
}
 
/**
  * returns the object passed in but with all keys recursively converted
  * to kebab-case; will recursively traverse arrays and their objects as
  * well.
* @param {object | object[]} obj
*/
export function kebabCaseKeys(obj) {
  return mapKeys(obj, kebabCase);
}

/**
 * returns the object passed in but with all keys recursively converted
 * to camel-case; will recursively traverse arrays and their objects as
 * well.
 * @param {object | object[]} obj
 */
export function camelCaseKeys(obj) {
  return mapKeys(obj, camelCase);
}
